import { createContext, useContext, type KeyboardEvent, type RefObject } from 'react';

type DraggableRow = {
	dragHandleRef: RefObject<HTMLButtonElement>;
	disallowDragWithMessage?: string;
	isDragHandleHidden: boolean;
	onContainerKeyDown: (e: KeyboardEvent<Element>) => void;
	onDragTargetKeyDown: (e: KeyboardEvent<Element>) => void;
	onDrag: () => void;
};

export const DraggableRowContext = createContext<DraggableRow | null>(null);

export function useDraggableRow(): DraggableRow {
	const context = useContext<DraggableRow | null>(DraggableRowContext);

	if (context == null) {
		throw new Error('Unable to retrieve DraggableRow context');
	}

	return context;
}
